import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString();
};

function EmployeesTable() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/employees`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEmployees(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load employees.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>All Employees</h1>
        <p>View all employee records</p>
      </div>

      <div className="section-card">
        <div className="header-actions">
          <h2>Employees ({employees.length})</h2>
          <button type="button" className="btn btn-secondary" onClick={fetchEmployees}>
            Refresh
          </button>
        </div>

        {error && <div className="error-message">{error}</div>}

        {employees.length === 0 ? (
          <p style={{ color: '#999' }}>No employees found.</p>
        ) : (
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>PAN ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {employees.map((emp) => (
                  <tr key={emp.id}>
                    <td>{emp.id}</td>
                    <td>{emp.pan_id || '-'}</td>
                    <td>{emp.name || '-'}</td>
                    <td>{emp.email || '-'}</td>
                    <td>{emp.phone || '-'}</td>
                    <td>
                      {emp.resignation_date ? (
                        <span className="badge danger">Resigned</span>
                      ) : (
                        <span className="badge success">Active</span>
                      )}
                    </td>
                    <td>{formatDate(emp.created_at)}</td>
                    <td>{formatDate(emp.updated_at)}</td>
                    <td>
                      <div className="btn-group" style={{ gap: '6px' }}>
                        <Link to={`/employees/${emp.id}/details`} className="btn btn-primary btn-sm link-btn">
                          Details
                        </Link>
                        <Link to={`/employees/${emp.id}/documents`} className="btn btn-secondary btn-sm link-btn">
                          Documents
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmployeesTable;
